import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

import { HeadlineAndDetails } from '@/components/HeadlineAndDetails'
import { ProfileActions } from '@/components/ProfileActions'

export const Route = createFileRoute('/_app/account')({
  component: AccountPage,
})

function AccountPage() {
  return (
    <Stack gap="sm">
      <HeadlineAndDetails title="My Account" description="" />
      <ProfileActions />
    </Stack>
  )
}
